import React from "react";
import LINKS from "./navLinks";

export default function Sidebar({ active, onNavigate, snapshot }) {
  const bridge = snapshot?.bridge || {};
  const connected = bridge.connected;
  return (
    <aside
      data-testid="sidebar-navigation-dock"
      className="hidden lg:flex flex-col fixed left-0 top-[68px] bottom-0 w-64 bg-[#0B0E17] border-r border-white/10 p-4 z-30 overflow-y-auto"
    >
      <div className="text-[10px] uppercase tracking-[0.14em] text-slate-500 px-3 mb-2">Workspace</div>
      <nav className="grid gap-1">
        {LINKS.map((l) => {
          const Icon = l.icon;
          const isActive = active === l.id;
          return (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => onNavigate(l.id)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-[13px] text-left transition-colors ${
                isActive
                  ? "text-slate-100 bg-[#142033] shadow-[inset_3px_0_0_0_#F59E0B]"
                  : "text-slate-400 hover:text-slate-100 hover:bg-[#141d2e]"
              }`}
            >
              <Icon size={17} className={isActive ? "text-amber-400" : "text-slate-500"} />
              {l.label}
            </button>
          );
        })}
      </nav>

      <div className="mt-auto pt-4">
        <div
          className={`rounded-xl p-3 border ${
            connected ? "border-emerald-500/20 bg-emerald-500/5" : "border-rose-500/20 bg-rose-500/5"
          }`}
        >
          <div className="flex items-center justify-between text-[11px]">
            <span className="text-slate-200">Bridge Windows</span>
            <span className={`font-mono font-bold ${connected ? "text-emerald-400" : "text-rose-400"}`}>
              {connected ? "ONLINE" : "OFFLINE"}
            </span>
          </div>
          <p className="text-[10px] leading-relaxed text-slate-400 mt-2">
            {bridge.account || "Account non rilevato"}
            <br />
            {bridge.machine || "In attesa del bridge"}
          </p>
        </div>
        <div className="flex items-center gap-2.5 mt-4 px-2">
          <div className="w-8 h-8 rounded-full grid place-items-center bg-[#22344a] text-amber-400 text-[11px] font-bold">
            OP
          </div>
          <div className="leading-tight">
            <div className="text-[11px] text-slate-200">Operatore XAUUSD</div>
            <div className="text-[10px] text-slate-500">Accesso libero · demo</div>
          </div>
        </div>
      </div>
    </aside>
  );
}
